module.exports = __webpack_public_path__ + "static/media/BM_NewUserQueue.f612a92a.svg";